export default __webpack_public_path__ + "static/media/watercolor.2363cf36.jpeg";